import { render, staticRenderFns } from "./Mail.vue?vue&type=template&id=2b2b2b8c&scoped=true&"
import script from "./Mail.vue?vue&type=script&lang=ts&"
export * from "./Mail.vue?vue&type=script&lang=ts&"
import style0 from "./Mail.vue?vue&type=style&index=0&id=2b2b2b8c&lang=scss&scoped=true&"
import style1 from "./Mail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b2b8c",
  null
  
)

export default component.exports